export const COLOR_STYLES = {
  accent: { bg: 'var(--accent-dim)', icon: 'var(--accent)' },
  blue: { bg: 'rgba(59, 130, 246, 0.1)', icon: 'rgb(59, 130, 246)' },
  amber: { bg: 'rgba(245, 158, 11, 0.1)', icon: 'rgb(245, 158, 11)' },
  purple: { bg: 'rgba(168, 85, 247, 0.1)', icon: 'rgb(168, 85, 247)' },
}

export type StatColour = keyof typeof COLOR_STYLES

export const STATUS_COLOURS: Record<string, string> = {
  collection: 'bg-blue-500',
  analysis: 'bg-purple-500',
  review: 'bg-amber-500',
  reporting: 'bg-emerald-500',
  closed: 'bg-slate-400',
  archived: 'bg-slate-300',
}

export const PRIORITY_COLOURS: Record<string, string> = {
  critical: 'bg-red-500',
  high: 'bg-orange-500',
  medium: 'bg-amber-500',
  low: 'bg-slate-400',
}
